import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <Box sx={{ minHeight: "100dvh", bgcolor: "background.default" }}>
      <Outlet />
    </Box>
  );
}
